module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-10.cafae6a4.png";